export const useBroadcast = (name: string) => {
    const channel = new BroadcastChannel(name)

    const postMessage = (message: any) => {
        channel.postMessage(message)
    }

    return {
        channel,
        postMessage,
    }
}
